<template>
    <div class="vip-u">
        <div class="vip-u-item w-full h-225px relative">
            <img src="@/assets/images/vip/vip-v.webp" alt="" class="w-full h-full absolute top-0 left-0 z-1"></img>
        </div>
        <div class="relative">
            <div v-if="[3, 4, 5].includes(userInfo?.role)"
                class="absolute top-0 left-50% -translate-x-1/2 w-100% flex justify-center items-center">
                <img src="@/assets/images/vip/caidai-vip.webp" alt="" class="w-302px h-71px"></img>
            </div>
            <div class="vip-u-text">
                {{ [3, 4, 5].includes(userInfo?.role) ? 'Lifetime VIP' : 'Join VIP' }}
            </div>
            <div class="vip-u-text-2">
                VIP Membership Benefits
            </div>
        </div>
        <div class="vip-u-benefit-box p-20px pt-40px">
            <div class="vip-u-benefit-list px-4px relative">
                <div
                    class="flex color-#FFFFFF h-50px relative lh-50px text-11px font-600  justify-between px-2px header-item">
                    <div class="w-170px text-left">
                        Member's Privileges
                    </div>
                    <div class="w-57px text-center color-#fff">
                        Ultra
                    </div>
                    <div class="w-57px text-center color-#fff">
                        Plus
                    </div>
                    <div class="w-57px text-center color-#8699FF">
                        VIP
                    </div>
                </div>
                <div class="overflow-y-auto" :class="[3, 4, 5].includes(userInfo?.role) ? 'h-36vh' : 'h-25vh'">
                    <div v-for="item in vipBenefitListTwo(vipPerks || {})"
                        class="text-12px flex items-center justify-between px-2px benefit-item h-40px">
                        <div class="w-170px text-center flex items-center">
                            <div class="mr-6px">
                                <img :src="item.titleImg" alt="" class="w-12px h-12px"></img>
                            </div>
                            <div class="color-#fff">
                                {{ item.title }}
                            </div>
                        </div>
                        <div class="w-57px justify-center items-center color-#BE8CFF flex">
                            <div class="flex items-center justify-center w-12px h-12px" v-if="item.crystalImg">
                                <img :src="item.crystalImg" alt="" class="w-100% h-100%"></img>
                            </div>
                            <div class="color-text-1 text-12px font-600">
                                {{ item.ultra }}
                            </div>
                            <div class="flex items-center justify-center w-12px h-12px" v-if="item.dui">
                                <img :src="item.dui" alt="" class="w-100% h-100%"></img>
                            </div>
                        </div>
                        <div class="w-57px text-center color-#fff flex items-center justify-center">
                            <div class=" " v-if="item.crystalImg">
                                <img :src="item.crystalImg" alt="" class="w-12px h-12"></img>
                            </div>
                            <div class=" " v-if="item.dui">
                                <img :src="item.dui" alt="" class="w-12px h-12"></img>
                            </div>

                            <div class="color-#fff mt-0px">
                                {{ item.plus }}
                            </div>
                        </div>
                        <div class="w-57px text-center flex items-center justify-center">
                            <div class=" " v-if="item.crystalImg">
                                <img :src="item.crystalImg" alt="" class="w-12px h-12"></img>
                            </div>
                            <div class=" " v-if="item.cuoImg">
                                <img :src="item.cuoImg" alt="" class="w-12px h-12"></img>
                            </div>
                            <div class=" " v-else>
                                <img :src="item.duiImg" v-if="item.duiImg" alt="" class="w-12px h-12"></img>
                            </div>
                            <div class="color-#8699FF">
                                {{ item.vip }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="top">
                </div>
            </div>
        </div>
        <div class="p-20px py-0! absolute bottom-0 left-0 right-0 bg-#19100F tab-box">
            <div class="color-#8699FF  flex items-center justify-center" v-if="[3, 4, 5].includes(userInfo?.role)">
                <div class="w-80% text-center h-76px pt-10px">
                    You are already a VIP member!
                </div>
            </div>
            <div v-else>
                <div class=" h-41px color-#fff text-center pl-2px lh-41px w-100%">
                    Just $1.99
                </div>
                <div class="subscribe-now-btn" @click="handleSubscribeNow">
                    Become VIP Now
                </div>
            </div>
            <div class="flex gap-10px color-text-1 justify-between py-10px">
                <div class="text-12px font-500 underline" @click="router.push('/terms')">
                    Terms of Use
                </div>
                <div class="text-12px font-500">
                    <!-- Cancel at any time -->
                </div>
                <div class="text-12px font-500 underline" @click="router.push('/policy')">
                    Privacy Policy
                </div>
            </div>
        </div>
        <!-- 挽留弹窗 -->
        <Transition name="retention-popup">
            <div v-if="showRetentionPopup" class="retention-popup-overlay" @click.self="handleCloseRetention">
                <div class="retention-popup-wrapper">
                    <div class="retention-popup-container">
                        <!-- 皇冠图标区域 -->
                        <div class="retention-icon-wrapper">
                            <div class="retention-icon-border">
                                <div class="retention-icon-circle">
                                    <img src="@/assets/images/vip/stay_icon.svg" alt="" class="retention-crown-icon">
                                </div>
                            </div>
                        </div>

                        <!-- 标题 -->
                        <div class="retention-title">Still hesitating?</div>

                        <!-- 描述 -->
                        <div class="retention-description">
                            Once unlocked, you won't need to worry about diamond consumption.
                        </div>

                        <!-- 按钮组 -->
                        <div class="retention-buttons">
                            <div class="retention-btn retention-btn-secondary" @click="handleCloseRetention">
                                Next time
                            </div>
                            <div class="retention-btn retention-btn-primary" @click="handleSubscribeNow">
                                Buy now
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script setup lang="ts">
import { theme } from '@/styles/theme'
import { computed } from 'vue'
import { ref } from 'vue'
import { vipBenefitListTwo } from '../index'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { useStorePageStore } from '@/stores/store'
import bridge from '@/utils/bridge'
const userStore = useUserStore()
const storePageStore = useStorePageStore()
const router = useRouter()
/**
 * 用户信息
 */
const userInfo = computed(() => userStore.userInfo)
/**
 * 挽留弹窗
 */
const showRetentionPopup = ref(false)
/**
 * 属性
 */
const props = defineProps({
    vipBenefitList: {
        type: Function,
        default: () => () => []
    },
    vipPerks: {
        type: Object,
        default: () => { }
    }
})

/**
 * 获取充值商品
 */
const storeItems = computed(() => {
    return storePageStore.rechargeItems?.[0]?.list?.[0] || null
})
/**
 * 购买
 */
const handleSubscribeNow = () => {
    localStorage.setItem('nowMsgCost', String(userStore.msgCost))
    bridge.callApp('inAppPayLoad', {
        item: storeItems.value,
        url: '/applePurchase'
    })
}
/**
 * 关闭挽留弹窗
 */
const handleCloseRetention = () => {
    showRetentionPopup.value = false
    showRetentionPopup.value = false
    router.back()

}

/**
 * 显示挽留弹窗
 */
const handleShowRetentionPopup = () => {
    showRetentionPopup.value = true
}

window.addEventListener('paymentResult', function () {
    showRetentionPopup.value = false
});

defineExpose({
    handleShowRetentionPopup
})
</script>

<style scoped lang="scss">
.vip-u {
    .vip-u-text {
        margin-top: 14px;
        text-align: center;
        // background: linear-gradient(0deg, #AD62F2 0%, #D4B3FF 47%, #AD62F2 100%);
        // background: linear-gradient(0deg, #EAB04E 0%, #FFDFB3 47%, #EAB04E 100%);
        background: linear-gradient(0deg, #6580FF 0%, #CBC9FF 44%, #6580FF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        font-weight: 800;
        font-size: 20px;
        font-style: italic;
    }

    .vip-u-text-2 {
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: v-bind('theme.colors.textPrimary');
    }

    .vip-u-benefit-box {
        .vip-u-benefit-list {
            border-radius: 15px;
            border: 1px solid #B5ADA1;

            // border-image: linear-gradient(180deg, rgba(174, 161, 181, 1), rgba(186, 138, 221, 1)) 1 1;
            .header-item {
                border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            }
        }
    }

    .top {
        width: 59px;
        height: calc(100% + 20px);
        position: absolute;
        bottom: 0px;
        border-radius: 10px 10px 10px 0;
        right: 0px;
        background-color: rgba(67, 58, 73, 1);
        opacity: 0.4;
    }

    .tab-box {
        box-shadow: 0px -4px 10px 2px rgba(0, 0, 0, 1);
    }

    .tab-subscribe-box {
        .tab-subscribe-item {
            padding-top: 11px;
            border-radius: 10px;
            // border: 1px solid #AEA1B5;
            background: #3B3433;
            border: 2px solid transparent;
            position: relative;

            &.subscribe-active {
                // background: linear-gradient(90deg, #1A1114 0%, #513568 100%);
                background: linear-gradient(90deg, #1A1114 0%, #684135 100%);
                border: none;

                &::before {
                    content: '';
                    position: absolute;
                    inset: -2px;
                    border-radius: 10px;
                    padding: 2px;
                    background: linear-gradient(90deg, rgba(255, 223, 179, 1), rgba(234, 176, 78, 1));
                    -webkit-mask:
                        linear-gradient(#fff 0 0) content-box,
                        linear-gradient(#fff 0 0);
                    -webkit-mask-composite: xor;
                    mask:
                        linear-gradient(#fff 0 0) content-box,
                        linear-gradient(#fff 0 0);
                    mask-composite: exclude;
                    pointer-events: none;
                    z-index: 0;
                }

                >* {
                    position: relative;
                    z-index: 1;
                }
            }
        }
    }

    .subscribe-now-btn {
        margin-top: 10px;
        width: 100%;
        height: 40px;
        // background: linear-gradient(90deg, #E9D6FF 0%, #A66CFE 100%);
        // background: linear-gradient( 90deg, #FFDFB3 0%, #EAB04E 100%);
        background: linear-gradient(90deg, #D6DFFF 0%, #6990FF 100%);
        border-radius: 35px;
        text-align: center;
        line-height: 40px;
        font-weight: 800;
        font-size: 15px;
        // color: #490D73;
        // color: #854A0D;
        color: #0D1D73;
    }
}


// 挽留弹窗样式
.retention-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.retention-popup-wrapper {
    width: 100%;
    max-width: 335px;
    padding: 1px;
    background: linear-gradient(135deg, rgba(214, 223, 255, 1), rgba(105, 144, 255, 1));
    border-radius: 20px;
    position: relative;
}

.retention-popup-container {
    width: 100%;
    background: linear-gradient(180deg, #1D265F 0%, #171A2A 100%);
    border-radius: 20px;
    padding: 30px 20px 20px;
    position: relative;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}

.retention-icon-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.retention-icon-border {
    position: relative;
    // padding: 8px;
    // border: 1px dashed rgba(214, 223, 255, 0.5);
    border-radius: 8px;
}

.retention-icon-circle {
    width: 107px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.retention-crown-icon {
    width: 100%;
    height: 100%;
}

.retention-title {
    text-align: center;
    font-size: 17px;
    font-weight: 900;
    color: #FFFFFF;
    margin-bottom: 12px;
}

.retention-description {
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 1.5;
    margin-bottom: 24px;
    opacity: 0.9;
}

.retention-buttons {
    display: flex;
    gap: 12px;
    justify-content: center;
}

.retention-btn {
    flex: 1;
    padding: 8px 20px;
    border-radius: 23px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
}

.retention-btn-secondary {
    background: rgba(255, 255, 255, 0.1);
    color: #FFFFFF;
    font-weight: 800;
    font-size: 14px;
    color: #FFFFFF;

    &:active {
        background: rgba(255, 255, 255, 0.2);
        transform: scale(0.98);
    }
}

.retention-btn-primary {
    // background: linear-gradient(90deg, #5A68FF 0%, #95A5FF 100%);
    background: linear-gradient(90deg, #D6DFFF 0%, #6990FF 100%);
    color: #FFFFFF;
    font-weight: 800;
    font-size: 15px;
    color: #0D1D73;

    &:active {
        opacity: 0.9;
        transform: scale(0.98);
    }
}
// 弹窗动画
.retention-popup-enter-active,
.retention-popup-leave-active {
    transition: opacity 0.3s ease;
}

.retention-popup-enter-active .retention-popup-wrapper,
.retention-popup-leave-active .retention-popup-wrapper {
    transition: transform 0.3s ease, opacity 0.3s ease;
}

.retention-popup-enter-from {
    opacity: 0;
}

.retention-popup-enter-from .retention-popup-wrapper {
    transform: scale(0.9) translateY(20px);
    opacity: 0;
}

.retention-popup-leave-to {
    opacity: 0;
}

.retention-popup-leave-to .retention-popup-wrapper {
    transform: scale(0.9) translateY(-20px);
    opacity: 0;
}
</style>